import { commonTypes } from '../common';

export const types = {
  SET_R2R_FILE_URL: 'PRODUCTOFFERING/SET_R2R_FILE_URL',
}

export const initialState = {
  productOfferingsToBuyInfo: {},
  afterSaleParentProduct: null,
  r2rFileUrl: null,
  r2rToCancelInfo: null,
};

const ApisNeedsProductOffering = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_R2R_TO_CANCEL_INFO: {
      const { newR2RToCancelInfo } = action.payload;

      return {
        ...state,
        r2rToCancelInfo: newR2RToCancelInfo
      }
    }
    case types.SET_R2R_FILE_URL: {
      const { r2rFileUrl } = action.payload;
      return {
        ...state,
        r2rFileUrl,
      };
    }
    case commonTypes.SET_PRODUCT_OFFERING_INFO: {
      const { productOfferingName, productOfferingTypes, productOfferingId } = action.payload;

      let newProductOfferingInfo = {
        ...state.productOfferingsToBuyInfo[productOfferingId],
      };
      if (productOfferingName) {
        newProductOfferingInfo = {
          ...newProductOfferingInfo,
          productOfferingName,
        };
      }
      if (productOfferingTypes) {
        newProductOfferingInfo = {
          ...newProductOfferingInfo,
          productOfferingTypes,
        };
      }
      return {
        ...state,
        productOfferingsToBuyInfo: {
          ...state.productOfferingsToBuyInfo,
          [productOfferingId]: { ...newProductOfferingInfo },
        },
      };
    }
    case commonTypes.SET_AFTER_SALE_PARENT_PRODUCT: {
      const { afterSaleParentProduct } = action.payload;

      return {
        ...state,
        afterSaleParentProduct,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setR2RFileUrl: r2rFileUrl => ({
    type: types.SET_R2R_FILE_URL,
    payload: {
      r2rFileUrl,
    },
  }),
};

export default ApisNeedsProductOffering;
